import React from 'react';

import { Modal, useModal } from "src/components/Modal/Modal";
import Refund from "src/components/Refund/Refund";
import ContextMenu from "src/components/ContextMenu/ContextMenu";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./StoreTransactionsTab.module.scss";

interface CustomTransactionCellRendererProps extends CustomCellRendererProps {
  clubId: string;
  getTransactions(): void;
}

export const ActionsRenderer = (props: CustomTransactionCellRendererProps) => {
  const { isShown, toggle } = useModal();

  const menuOptions = [{
    label: "Refund Transaction",
    onClick: () => {
      toggle();
    }
  }];

  return (
    <div className={styles.ActionRenderer}>
      <ContextMenu options={menuOptions} />
      <Modal
        className="refundModal"
        isShown={isShown}
        hide={() => { toggle(); }}
        modalContent={
          <Refund
            type="store"
            clubId={props.clubId}
            transaction={props.data.transaction}
            onRefund={() => {
              toggle();
              props.getTransactions();
            }}
            onCancel={() => {
              toggle();
            }}
          />
        }
      />
    </div>
  );
};

